import { gql } from '@apollo/client';
import axios, { AxiosResponse } from 'axios';

import { GET_PROGRAM_TOPICS } from 'services';
import { getCurrentUserInfo } from 'services/amplify';
import { executeApollo } from 'services/api/api';
import { LibraryProgram, LibraryProgramTopic } from 'services/programs';
import { getStrapiEndpoint } from 'services/strapi';

import { PageType } from './types';

const GET_PROGRAMS = gql`
  query getProgramsList {
    programs(
      where: { active: true, program_topics: { topic: { active: true } } }
      sort: "title_key"
    ) {
      id
      titleKey: title_key
      description
      createdAt: created_at
      programTopics: program_topics {
        topic {
          titleKey: title_key
        }
      }
    }
  }
`;

const getPrograms = async () => {
  try {
    const { username } = await getCurrentUserInfo();
    const { data } = await executeApollo({
      query: GET_PROGRAMS,
      variables: {
        cognitoId: username,
      },
    });

    return data?.programs;
  } catch (error) {
    throw new Error('ERROR.TRY');
  }
};

const getPageContent = async (token: string, page: string) => {
  const strapiUrl = await getStrapiEndpoint();
  try {
    const { data } = await axios.get<void, AxiosResponse<PageType>>(
      `${strapiUrl}/pages/${page}`,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      },
    );

    return data;
  } catch {
    throw new Error('Failed to retrieve page');
  }
};

const getProgramTopics = async (programId: number): Promise<LibraryProgram> => {
  try {
    const { data } = await executeApollo({
      query: GET_PROGRAM_TOPICS,
      variables: {
        programId,
      },
    });

    const { programTopics, ...rest } = data?.programs[0];
    const topics = programTopics.map((programTopic: LibraryProgramTopic) => {
      return programTopic.topic;
    });

    return { ...rest, topics };
  } catch {
    throw new Error('Unexpected error while retrieving program topics');
  }
};

export {
  GET_PROGRAMS,
  getPrograms,
  getPageContent,
  getProgramTopics,
  executeApollo,
};
